var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data &&
    _vm.data.reviews &&
    _vm.data.reviews.length >= 1 &&
    _vm.dataLoaded &&
    _vm.data.rating365 > 4
    ? _c("div", { staticClass: "ts-widget" }, [
        _c("div", { staticClass: "inner" }, [
          _c(
            "div",
            { staticClass: "glide-badgex" },
            [
              _c("div", { staticClass: "badgex" }, [
                _c("div", {
                  staticClass: "hl",
                  domProps: { innerHTML: _vm._s(_vm.$attrs.lang1) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "txt" }, [
                  _c("div", { staticClass: "txt-inner" }, [
                    _c("strong", { staticClass: "rate" }, [
                      _vm._v(
                        _vm._s(_vm.data.rating365.toString().replace(".", ","))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "stars-container" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "rate-full",
                          style: "width:" + _vm.data.rating365 * 20 + "%",
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-star",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-star",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-star",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-star",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-star",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "counts" }, [
                    _c("span", { staticClass: "total365" }, [
                      _vm._v(
                        _vm._s(_vm.data.count365) +
                          " " +
                          _vm._s(_vm.$attrs.lang2)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("strong", { staticClass: "total" }, [
                      _vm._v(
                        _vm._s(_vm.data.overallCount) +
                          " " +
                          _vm._s(_vm.$attrs.lang3)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        _vm._s(_vm.$attrs.lang4) +
                          " " +
                          _vm._s(
                            _vm.data.calculatedAt.split("T")[0].split("-")[2]
                          ) +
                          "." +
                          _vm._s(
                            _vm.data.calculatedAt.split("T")[0].split("-")[1]
                          ) +
                          "." +
                          _vm._s(
                            _vm.data.calculatedAt.split("T")[0].split("-")[0]
                          )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(1),
              ]),
              _vm._v(" "),
              _c(
                "vue-glide",
                _vm._b(
                  { ref: "vueglider", on: { "glide:mount-after": _vm.update } },
                  "vue-glide",
                  _vm.settings,
                  false
                ),
                [
                  _vm._l(_vm.data.reviews, function (review, index) {
                    return _c("vue-glide-slide", { key: index }, [
                      _c("div", { staticClass: "date-stars" }, [
                        _c("div", { staticClass: "date" }, [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                review.name && review.name != ""
                                  ? review.name.trim()
                                  : _vm.$attrs.lang5
                              ),
                            },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                review.submittedAt.split("T")[0].split("-")[2]
                              ) +
                              "." +
                              _vm._s(
                                review.submittedAt.split("T")[0].split("-")[1]
                              ) +
                              "." +
                              _vm._s(
                                review.submittedAt.split("T")[0].split("-")[0]
                              ) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "stars" },
                          [
                            _vm._l(review.rating * 1, function (index) {
                              return [
                                _c("i", {
                                  staticClass: "fa fa-star",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            }),
                            _vm._v(" "),
                            _vm._l(5 - review.rating * 1, function (index) {
                              return [
                                _c("i", {
                                  staticClass: "fa fa-star grey",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "comment" }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(review.comment.trim()),
                          },
                        }),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  _c("template", { slot: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "p",
                        attrs: {
                          "data-glide-dir": "<",
                          "data-builder-clickable": "",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "n",
                        attrs: {
                          "data-glide-dir": ">",
                          "data-builder-clickable": "",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-right",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "rate-blank" }, [
      _c("i", { staticClass: "fa fa-star", attrs: { "aria-hidden": "true" } }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star", attrs: { "aria-hidden": "true" } }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star", attrs: { "aria-hidden": "true" } }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star", attrs: { "aria-hidden": "true" } }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star", attrs: { "aria-hidden": "true" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "icon",
        attrs: {
          href: "https://www.trustedshops.de/bewertung/info_XC20B8AA148B030F2B75205A3ACEFE5E7.html",
          target: "_blank",
        },
      },
      [
        _c("img", {
          staticClass: "lazyload",
          attrs: {
            src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0AQMAAADxGE3JAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAADVJREFUeNrtwTEBAAAAwiD7p/ZZDGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOX0AAAEidG8rAAAAAElFTkSuQmCC",
            "data-src":
              "https://cdn02.plentymarkets.com/4ef9772fo0y5/frontend/ts.webp",
            alt: "",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }